import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import CofinsCstService from 'business/cadastro/fiscal/cofinsCst/cofinsCstService'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabPanel, TabView } from 'primereact/tabview'
import { createCodeDescriptionObject } from 'helper/formater'
import { defaultEmptySelection } from 'helper/default'
import { errorToToast } from 'helper/error'
import TipoFluxoService from 'business/cadastro/fiscal/tipoFluxo/tipoFluxoService'

export default function CofinsCst() {

    const [service] = useState(() => new CofinsCstService())
    const [tipoFluxos, setTipoFluxos] = useState([])

    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        if (data?.tipo_fluxo) {
            setTipoFluxos([createCodeDescriptionObject(data.tipo_fluxo, 'codigo_tiflu', 'descricao_tiflu')])
        }

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(schema => {
            setValidations(schema)
        })
    }, [service])

    const loadTipoFluxos = async () => {
        const srv = new TipoFluxoService()
        await srv.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tiflu', 'descricao_tiflu'))
            options.push({ codigo_tiflu: null, descricao_tiflu: defaultEmptySelection() })
            setTipoFluxos(options)
        }).catch(err => errorToToast({ err, toast }))
    }

    return (
        <FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-3" field="descricao_cofcst" form={form} service={service} type="text" clearString label="Descrição" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-3" field="cod_tiflu_cofcst" form={form} type="dropdown2" service={service} label="Tipo de fluxo"
                            optionKey='codigo_tiflu'
                            optionLabel='descricao_tiflu'
                            options={tipoFluxos}
                            onLoad={loadTipoFluxos}
                        />
                    </GridForm>
                </TabPanel>

                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0}>
                    <GridForm></GridForm>
                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
